import { EmergencyPowerSettingsModel } from 'src/Libs/emergency-power'
import { SocketStateModel, useWebSocketApi } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { EmergencyPowerSettingsDto } from '../api'
import { fromDtoToModel } from '../transformers'
import { isUndefined } from 'lodash'

const SERVICE_ID = '[EMERGENCY POWER]'

/**
 * This hook provides the utils for accessing the Emergency Power settings and overviews through a websocket connection.
 * The returning information comes directly from the connected device.
 *
 * It always returns a valid model, containing at first with initial default data and in the followup with the last
 * valid fetched data, to ensure data stability.
 *
 * @param storageId
 * @param doNotInitialize
 */
const useLiveEmergencyPower = (storageId: string | undefined, doNotInitialize?: boolean): SocketStateModel<EmergencyPowerSettingsModel> => {
  const webSocketApiPath = `storages/${storageId}/hardware/emergency-power/overview/ws`

  const { socketState } = useWebSocketApi<EmergencyPowerSettingsModel, EmergencyPowerSettingsDto>({
    apiResourcePath: webSocketApiPath,
    loggerKey: SERVICE_ID,
    transformer: fromDtoToModel,
    dependencies: [storageId],
    doNotInitialize: isUndefined(storageId) || doNotInitialize,
    endpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  })

  return socketState
}

export default useLiveEmergencyPower
